import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";

import { GeneralResponse } from "../../../types/api";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import { IUserLoginRequest } from "../../../types/apis/auth-apis";

export const UserLogin = async (
  payload: IUserLoginRequest,
): Promise<GeneralResponse> => {
  try {
    const response = await Api<any, GeneralResponse<IUserLoginRequest>>({
      method: Methods.POST,
      endpoint: EndPoints.userLogin,
      body: payload,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useUserLogin = (options = {}) => {
  const mutation: UseMutationResult<GeneralResponse, Error, IUserLoginRequest> =
    useMutation({
      mutationFn: UserLogin,
      ...options,
    });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
